import PropTypes from 'prop-types';
import {SortableHandle} from 'react-sortable-hoc';
import {Icon, Reveal} from 'semantic-ui-react';

const Indenter = ({className, content, style}) => (
  <span className={className} style={{
    display: 'inline-block',
    height: '100%',
    width: '2rem',
    textAlign: 'center',
    ...style,
  }}>
    {content}
  </span>
);

Indenter.propTypes = {
  className: PropTypes.string,
  content: PropTypes.node.isRequired,
  style: PropTypes.object,
};


const DragHandle = SortableHandle(() => {
  return (
    <Reveal animated="fade" className="drag-handle" instant style={{cursor: 'move'}} tabIndex={0}>
      <Reveal.Content visible>
        <Indenter content={<Icon name="sort" color="grey" inverted/>}/>
      </Reveal.Content>
      <Reveal.Content>
        <Indenter content={<Icon className="active" color="blue" name="sort"/>}/>
      </Reveal.Content>
    </Reveal>
  );
});

export {Indenter, DragHandle};